import React from 'react';
import styles from './KopKnapp.module.css';

interface KopKnappProps {
  visaKopKnappGeometrier: boolean;
  setVisaKopKnapp: (visaKopKnapp: boolean) => void;
  hamtaBeteckning: () => void;
}

const KopKnapp = (props: KopKnappProps) => {
  const stangKopKnapp = () => {
    props.setVisaKopKnapp(false);
  };

  return (
    <div
      id="kopKnapp"
      className={`${
        props.visaKopKnappGeometrier ? styles.activeKKG : styles.inactiveKKG
      }`}
    >
      <div className={styles.placeExpander}></div>
      <div className={styles.buyButton} onClick={props.hamtaBeteckning}>
        Hämta fastighet
      </div>
      <div className={styles.closeButton} onClick={stangKopKnapp}>
        X
      </div>
    </div>
  );
};

export default KopKnapp;
